import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import useLenis from "@/hooks/useLenis";
import {
  LangLayout,
  LangHomeRedirect,
  LegacyRedirect,
  RootRedirect,
  ScrollToTop,
} from "@/components/LangLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import GradesPage from "@/pages/GradesPage";
import GradePage from "@/pages/GradePage";
import NewsPage from "@/pages/NewsPage";
import ApplicationsPage from "@/pages/ApplicationsPage";
import QualityPage from "@/pages/QualityPage";
import ContactPage from "@/pages/ContactPage";

// /export-logistics merged into the Export & Quality page — keep old links working.
const LegacyExportRedirect = () => {
  const { lang } = useParams();
  return <Navigate to={`/${lang}/quality`} replace />;
};

function App() {
  useLenis();

  return (
    <HelmetProvider>
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="bottom-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/:lang" element={<LangLayout />}>
              <Route index element={<HomePage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="grades" element={<GradesPage />} />
              <Route path="grades/:code" element={<GradePage />} />
              <Route path="export-logistics" element={<LegacyExportRedirect />} />
              <Route path="news" element={<NewsPage />} />
              <Route path="applications" element={<ApplicationsPage />} />
              <Route path="quality" element={<QualityPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="*" element={<LangHomeRedirect />} />
            </Route>
            <Route path="*" element={<LegacyRedirect />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
